<template>
  <div class="doc-content">
    <section class="doc-header">
      <h1>Iniciar Sesión</h1>
      <p class="lead">Vista que permite iniciar sesión a un usuario en el sistema.</p>
    </section>

    <plataformaNavegacion @cambio-plataforma="actualizarVista" />
    <hr />

    <div v-if="plataforma === 'web'" class="platform-content">
      <section class="doc-section">
        <h2>Datos de Acceso</h2>
        <p>Para ingresar a la plataforma, se requieren los siguientes parámetros:</p>
        <ul>
          <li><strong>Nombre del usuario:</strong> Identificador único con el que inicia sesión el usuario.</li>
          <li><strong>Contraseña:</strong> Valor secreto vinculado a la cuenta.</li>
          <li><strong>Servidor:</strong> Dirección IP o dominio y puerto del servidor al que se va a conectar.</li>
        </ul>
      </section>

      <section class="doc-section">
        <h2>Pasos para Ingresar</h2>
        <ol>
          <li>Introducir usuario, contraseña y servidor.</li>
          <li>Hacer clic al botón <strong>INICIAR SESIÓN</strong>.</li>
        </ol>
      </section>

      <section class="doc-visual">
        <h3>Referencia Visual</h3>
        <CarruselAciqui :items="imagenesLoginWeb" />
      </section>

      <section class="info-grid">
        <div class="info-card">
          <p>
            Después del primer inicio de sesión el campo de servidor aparece con la última dirección ingresada.
          </p>
          <p class="note-footer">
            <strong>Nota:</strong> la dirección del servidor solo será almacenada si el navegador se encuentra
            configurado para guardar las variables locales.
          </p>
        </div>
      </section>
    </div>

    <div v-if="plataforma === 'moviles'" class="platform-content">
      <section class="doc-section">
        <h2>Datos de Acceso</h2>
        <p>Para ingresar a la plataforma, se requieren los siguientes parámetros:</p>
        <ul>
          <li><strong>Nombre del usuario:</strong> Identificador único con el que inicia sesión el usuario.</li>
          <li><strong>Contraseña:</strong> Valor secreto vinculado a la cuenta.</li>
          <li><strong>Servidor:</strong> Dirección IP o dominio y puerto del servidor al que se va a conectar.</li>
        </ul>
      </section>

      <section class="doc-section">
        <h2>Pasos para Ingresar</h2>
        <ol>
          <li>Introducir usuario, contraseña y servidor.</li>
          <li>Hacer clic al botón <strong>INICIAR SESIÓN</strong>.</li>
        </ol>
      </section>

      <section class="doc-visual">
        <h3>Referencia Visual</h3>
        <CarruselAciqui :items="imagenesLogin" />
      </section>

      <section class="info-grid">
        <div class="info-card">
          <p>
            Después del primer inicio de sesión el campo de servidor aparece con la última dirección ingresada.
          </p>
          <p class="note-footer">
            <strong>Nota:</strong> la dirección del servidor solo será almacenada si el navegador se encuentra
            configurado para guardar las variables locales.
          </p>
        </div>
      </section>
    </div>



  </div>
</template>

<script>
import CarruselAciqui from './Carruselimg.vue';
import plataformaNavegacion from './BotonesNavegacion.vue';

export default {
  name: 'LoginDoc',
  components: {
    CarruselAciqui,
    plataformaNavegacion
  },
  data() {
    return {
      plataforma: 'web',
      imagenesLogin: [
        {
          nombre: "Inicio de sesión",
          url: "img/instalacion_android/login.jpg",
          descripcion: ""
        }
      ],
      imagenesLoginWeb: [
        {
          nombre: "Inicio de sesión",
          url: "img/Inicio_sesion/inicio_sesion_web.png",
          descripcion: ""
        }
      ]
    }
  },
  methods: {
    actualizarVista(val) {
      this.plataforma = val;
    }
  }
}
</script>

<style scoped>
/* Estos estilos complementan tu ayuda-styles.css para dar orden */
.doc-content {
  line-height: 1.6;
  color: inherit;
}

h1 {
  font-size: 2rem;
  margin-bottom: 0.5rem;
  color: #3b82f6;
}

h2 {
  font-size: 1.5rem;
  margin-top: 2rem;
  border-bottom: 1px solid #eaecef;
  padding-bottom: 0.3rem;
}

h3 {
  font-size: 1.1rem;
  margin-top: 1.5rem;
  color: #666;
}

.lead {
  font-size: 1.1rem;
  color: #6a737d;
}

ul,
ol {
  padding-left: 2rem;
  margin-bottom: 1rem;
}

li {
  margin-bottom: 0.5rem;
}

.figure-caption {
  text-align: center;
  font-size: 0.9rem;
  color: #586069;
  margin-top: 10px;
  font-weight: bold;
}

.alert-info {
  background-color: #f6f8fa;
  border-left: 0.25em solid #3b82f6;
  padding: 1rem;
  margin-top: 2rem;
  border-radius: 3px;
}

.note-footer {
  font-size: 0.9rem;
  margin-top: 10px;
  font-style: italic;
}
</style>